import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { useDocumentTitle } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { paths } from '@/utils/paths';

/** Unknown path inside the admin shell. */
export function NotFoundPage() {
  const { t } = useTranslation();
  useDocumentTitle(t('page.notFoundTitle'));
  return (
    <Center py={96}>
      <Stack align="center" gap="xs" ta="center">
        <Text fz={56} fw={700} c="gray.3" lh={1}>
          404
        </Text>
        <Title order={3}>{t('page.notFoundTitle')}</Title>
        <Text c="dimmed">{t('page.notFoundText')}</Text>
        <Button component={Link} to={paths.dashboard} variant="light" mt="sm">
          {t('page.toDashboard')}
        </Button>
      </Stack>
    </Center>
  );
}
